import { render } from "./daytwo.vue?vue&type=template&id=2e3e1b00"
import script from "./daytwo.vue?vue&type=script&lang=js"
export * from "./daytwo.vue?vue&type=script&lang=js"

import "./daytwo.vue?vue&type=style&index=0&id=2e3e1b00&lang=scss"
script.render = render

export default script